import React, { useMemo, useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import NumberKeyboard from "./numberKeyboard";
import { KioskStepContainer } from "../styled/common"; // 경로 맞춰

const PinFields = ({ transformValue, formData, handleChangeInput }) => {
  const [show, setShow] = useState(false);

  const raw = useMemo(() => {
    return (formData.password || "").replace(/\D/g, "").slice(0, 4);
  }, [formData.password]);

  const displayValue = useMemo(() => {
    if (!raw) return "";
    return show ? raw : "●".repeat(raw.length);
  }, [raw, show]);

  return (
    <KioskStepContainer
      className="slideContent"
      style={{ transform: `translateX(${transformValue}%)` }}
    >
      <div className="wrap">
        <div className="header">
          <div className="badge">STEP 3</div>
          <div className="title">비밀번호 설정</div>
          <div className="sub">찾을 때 사용됩니다. 숫자 4자리를 입력해주세요.</div>
        </div>

        <div className="card">
          <div className="inputBar hasRight">
            <input type="text" value={displayValue} readOnly placeholder="●●●●" />
            <button
              type="button"
              className="rightBtn"
              onClick={() => setShow((v) => !v)}
              aria-label={show ? "비밀번호 숨기기" : "비밀번호 보기"}
            >
              {show ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>

          <div className="body">
            <NumberKeyboard
              type="password"
              inputValue={formData.password}
              handleChangeInput={handleChangeInput}
            />
          </div>
        </div>
      </div>
    </KioskStepContainer>
  );
};

export default PinFields;